import {DocumentNode} from 'graphql';
import gql from 'graphql-tag';

export const SELECT_SUBTEMPLATE_FROM_TEMPLATECOLLECTIONS_QUERY = gql`
  query SelectSubTemplateFromTemplateCollectionsQuery @skipAudit @engComponent(name: NOTEBOOK) {
    templateCollections(onlySubtemplates: true) {
      ... on TemplateCollectionNode {
        id
        name
        archiveRecord {
          purpose
        }
        counts
        modifiedAt
        ownerJson
        star {
          id
          isStarred
        }
        children: subtemplates {
          ... on SubtemplateNode {
            id
            name
            creator {
              id
              name
            }
            modifiedAt
            star {
              id
              isStarred
            }
            archiveRecord {
              purpose
            }
            currentPublishingRecord {
              ... on PublishingRecordNode {
                id
                publishingStatus
              }
            }
          }
        }
      }
    }
  }
`;

export const SELECT_TEMPLATE_FROM_TEMPLATECOLLECTIONS_QUERY = gql`
  query SelectTemplateFromTemplateCollectionsQuery($excludeTaskSchemaExecutionTemplates: StrictBoolean)
  @skipAudit
  @engComponent(name: NOTEBOOK) {
    templateCollections(onlySubtemplates: false) {
      ... on TemplateCollectionNode {
        id
        name
        archiveRecord {
          purpose
        }
        counts
        modifiedAt
        ownerJson
        star {
          id
          isStarred
        }
        children: templates(excludeTaskSchemaExecutionTemplates: $excludeTaskSchemaExecutionTemplates) {
          ... on TemplateNode {
            id
            name
            creator {
              id
              name
            }
            modifiedAt
            star {
              id
              isStarred
            }
            archiveRecord {
              purpose
            }
            currentPublishingRecord {
              ... on PublishingRecordNode {
                id
                publishingStatus
              }
            }
          }
        }
      }
    }
  }
`;

export type CollectibleType = 'TEMPLATE' | 'SUB-TEMPLATE';

interface TemplateSelectionText {
  name: string;
  namePlural: string;
  idStartsWith: string;
  apolloQuery: DocumentNode;
  headers: Array<string>;
  columnWidths: Array<string>;
}

type TemplateSelectionTextMap = {
  [key in CollectibleType]: TemplateSelectionText;
};

const COMMON_TEMPLATE_SELECTION_TEST: Pick<TemplateSelectionText, 'headers' | 'columnWidths'> = {
  headers: ['Name', '', '', ''],
  columnWidths: ['100%', '16px', '20px', '16px'],
};

export const TemplateCollectionBrowserText: TemplateSelectionTextMap = {
  TEMPLATE: {
    ...COMMON_TEMPLATE_SELECTION_TEST,
    name: 'entry template',
    namePlural: 'entry templates',
    idStartsWith: 'tmpl_',
    apolloQuery: SELECT_TEMPLATE_FROM_TEMPLATECOLLECTIONS_QUERY,
  },
  'SUB-TEMPLATE': {
    ...COMMON_TEMPLATE_SELECTION_TEST,
    name: 'sub-template',
    namePlural: 'sub-templates',
    idStartsWith: 'sbtmpl_',
    apolloQuery: SELECT_SUBTEMPLATE_FROM_TEMPLATECOLLECTIONS_QUERY,
  },
};
